module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/rollers.png?02be603e9c35a333f54aa5d1c8c56c72";